import { getSignUpAuth } from '@/config/auth';
import throwClientError from './helpers/throwClientError';
export default async function resendVerifyUserCode(email) {
    try {
        await getSignUpAuth().resendSignUp(email.toLowerCase());
        return {};
    }
    catch (error) {
        return throwClientError(error);
    }
}
